<script>
export default {
  props: {
    competitions: { type: Array, required: true },
  },
}
</script>

<template>
  <div class="bg-white mt-8 mx-7.5 p-8 rounded-xl shadow-lg">
    <div v-if="!competitions.length" class="w-full text-center">
      No data.
    </div>
    <div
      v-for="challenge in competitions"
      v-else
      :key="challenge.id"
      class="text-blue"
    >
      <router-link
        :to="{
          name: 'challengesDetail',
          params: { challengeId: challenge.id, challenge },
        }"
      >
        &gt; {{ challenge.name }}
      </router-link>
    </div>
  </div>
</template>
